import message from 'antd/lib/message';
import * as ApikoApi from '../../api/apiko-api';
import {
  inviteUserRequest,
  acceptInvitationsRequest,
  acceptInvitationsEnd,
  cancelUserInvitation,
} from '../actions/invitations';

/**
 * inviteUser :: Object -> Func -> Promise Error _
 */
export const inviteUser = data => dispatch =>
  Promise.resolve(dispatch(inviteUserRequest()))
    .then(() => ApikoApi.inviteUser(data));

export const fetchInvitationsUserInfo = _id => () =>
  ApikoApi.fetchInvitationsUserInfo(_id);

export const acceptInvitations = (invitationSecret, data) => (dispatch) => {
  dispatch(acceptInvitationsRequest());
  return ApikoApi.acceptInvitations(invitationSecret, data)
    .then(() => dispatch(acceptInvitationsEnd()))
    .catch((err) => {
      console.log(err);
      dispatch(acceptInvitationsEnd());
    });
};

/**
 * handleCancelInvitation :: String -> Func -> Promise Error _
 */
export const handleCancelInvitation = _id => dispatch =>
  ApikoApi.cancelInvitationById(_id)
    .then(user => dispatch(cancelUserInvitation(user)))
    .then(() => message.success('Invitation successfully canceled'))
    .catch(err => message.error(err.response.data.error.message));



// WEBPACK FOOTER //
// ./src/redux/thunk/invitations.js